
import { authflowapi } from 'apprise-core/auth';
import { User } from 'apprise-core/user';
import { useT } from 'apprise-frontend-core/intl/language';
import { useFeedback } from 'apprise-ui/utils/feedback';
import { useLoginState } from './context';



export const useLogged = () => useLogin().logged()


export const useBetaTester = () => useLogged()?.username

export type LogoutProperties = Partial<{

    askConsent: boolean,
    useAuth: boolean
}>


export const useLogin = () => {

    const state = useLoginState()

    const t = useT()

    const feedback = useFeedback()


    const self = {

        logged: () => state.get().logged

        ,

        logout: (props?: LogoutProperties) => {

            const { askConsent, useAuth= true } = props ?? {}

            const logout = () => {

                if (useAuth)

                    window.location.href = authflowapi().logout()

                else 
                    window.location.reload()
                
            }

            if (askConsent) {

                feedback.ask({
                    title: t('user.login_title'),
                    body: t('user.login_message'),
                    okText: t('user.login_btn'),
                    noValediction: true,
                    noCancel: true,

                }).thenRun(logout)

            }

            else logout()
        }


        ,

        // store logged user and remember it for next reload if we don't have AuthN active.
        // (this supports testing with different users when AuthNs is off)
        login: (user: User) => self.setLogged(user)
        

        ,

        setLogged: (user: User) => {

            state.set(s => s.logged = user)


        }


    }


    return self


}


